// extracted by mini-css-extract-plugin
export default {"button":"TheButton_button__Kzb9l"};